import { getUserInfo, updateUserInfo } from '@/api/user'
import { getUserInfo as getUserSubInfo } from '@/apiv4/user'
import Cookies from 'js-cookie'

const user = {
  state: {
    userId: _getCookies('userId') || '',
    mobile: _getCookies('mobile') || '',
    nickname: _getCookies('nickname') || '',
    avatarUrl: _getCookies('avatarUrl') || '',
    isVip: false, // 不要缓存vip状态
    vipCount: 0,
    isSub: 0,
    token: _getCookies('token') || '', // 注意cookie名要加 user. 前缀
    v4token: Cookies.get('v4token') || '', // v4的token，不要加token前缀，不要加 user. 前缀
  },
  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId
      _setCookies('userId', userId)
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
      _setCookies('mobile', mobile)
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
      _setCookies('nickname', nickname)
    },
    SET_AVATARURL: (state, avatarUrl) => {
      state.avatarUrl = avatarUrl
      _setCookies('avatarUrl', avatarUrl)
    },
    SET_ISVIP: (state, isVip) => {
      state.isVip = isVip
    },
    SET_VIPCOUNT: (state, vipCount) => {
      state.vipCount = vipCount
    },
    SET_ISSUB: (state, isSub) => {
      state.isSub = isSub
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      _setCookies('token', token)
    },
    SET_V4TOKEN: (state, v4token) => {
      state.v4token = v4token.token
      Cookies.set('v4token', v4token.token, { expires: new Date(v4token.expireTime) })
    }
  },
  actions: {
    async setV4token({ commit }, v4token) {
      commit('SET_V4TOKEN', v4token)
    },

    async getUserinfo({ commit }, authToken) {
      try {
        let userinfo = await getUserInfo(authToken)
        commit('SET_USERID', userinfo.user.user_id)
        commit('SET_MOBILE', userinfo.user.mobile)
        commit('SET_NICKNAME', userinfo.user.nickname)
        commit('SET_AVATARURL', userinfo.user.avatar_url)
        commit('SET_ISVIP', userinfo.vip)
        commit('SET_VIPCOUNT', userinfo.vip_count)
        commit('SET_TOKEN', userinfo.token)
        // 兼容官网登录
        Cookies.set('token', userinfo.token, { expires: 25 })
      } catch (e) {
        console.log(e)
      }
    },

    async updateUserinfo({ commit }, token) {
      try {
        let userinfo = await updateUserInfo(token)
        commit('SET_USERID', userinfo.user.user_id)
        commit('SET_MOBILE', userinfo.user.mobile)
        commit('SET_NICKNAME', userinfo.user.nickname)
        commit('SET_AVATARURL', userinfo.user.avatar_url)
        commit('SET_ISVIP', userinfo.vip)
        commit('SET_VIPCOUNT', userinfo.vip_count)
      } catch (e) {
        console.log(e)
      }
    },

    async getUserSubInfo({ commit }) {
      try {
        let userSubInfo = await getUserSubInfo()
        commit('SET_ISSUB', userSubInfo.data.is_subscribe)
      } catch (e) {
        console.log(e)
      }
    },

    clearUserinfo({ commit }) {
      commit('SET_USERID', '')
      commit('SET_MOBILE', '')
      commit('SET_NICKNAME', '')
      commit('SET_AVATARURL', '')
      commit('SET_ISVIP', false)
      commit('SET_VIPCOUNT', 0)
      commit('SET_TOKEN', '')
      commit('SET_ISSUB', 0)
      _removeUserCookies()
    }
  }
}

// 默认缓存data天
function _setCookies(name, value, date = 25) {
  name = 'user.' + name
  Cookies.set(name, value, { expires: date })
}

function _getCookies(name) {
  name = 'user.' + name
  return Cookies.get(name)
}

function _removeUserCookies() {
  let cookiesMap = Cookies.get()
  for (let name in cookiesMap) {
    if (/^user\./.test(name)) {
      Cookies.remove(name)
    }
  }
  // 兼容ilisten域名下其他站点登录
  Cookies.remove('token')
}

export default user
